import React from "react";
import { MSection } from "components/misc";
import { Row, Col } from "design-react-kit";
import { Helmet } from "react-helmet";
import { pageService, payloadBuilder } from "libs";

import {
  ValidatedForm,
  MInput,
  MSelect,
  MCheckbox,
} from "components/forms";

export class FormTfaSostegnoEsteroView extends ValidatedForm {
  constructor(props) {
    super(props);
    this.state = {
      ...this.emptyFields,
      defaultValues: { ...this.emptyFields },
      formActive: true,
      regions: [],
      isChecked: false,
      isSuccess: 0,
    };
  }

  PAYLOAD_REGION = {
    options: [
      {
        label: "Seleziona Regione",
        value: "",
      },
      {
        label: "Abruzzo",
        value: "Abruzzo",
      },
      {
        label: "Basilicata",
        value: "Basilicata",
      },
      {
        label: "Calabria",
        value: "Calabria",
      },
      {
        label: "Campania",
        value: "Campania",
      },
      {
        label: "Emilia-Romagna",
        value: "Emilia-Romagna",
      },
      {
        label: "Friuli-Venezia Giulia",
        value: "Friuli-Venezia Giulia",
      },
      {
        label: "Lazio",
        value: "Lazio",
      },
      {
        label: "Liguria",
        value: "Liguria",
      },
      {
        label: "Lombardia",
        value: "Lombardia",
      },
      {
        label: "Marche",
        value: "Marche",
      },
      {
        label: "Molise",
        value: "Molise",
      },
      {
        label: "Piemonte",
        value: "Piemonte",
      },
      {
        label: "Puglia",
        value: "Puglia",
      },
      {
        label: "Sardegna",
        value: "Sardegna",
      },
      {
        label: "Sicilia",
        value: "Sicilia",
      },
      {
        label: "Toscana",
        value: "Toscana",
      },
      {
        label: "Trentino-Alto Adige/Südtirol",
        value: "Trentino-Alto Adige/Südtirol",
      },
      {
        label: "Umbria",
        value: "Umbria",
      },
      {
        label: "Valle d'Aosta/Vallée d'Aoste",
        value: "Valle d'Aosta/Vallée d'Aoste",
      },
      {
        label: "Veneto",
        value: "Veneto",
      },
    ],
  };

  emptyFields = {
    name: "",
    surname: "",
    dob: "",
    email: "",
    mobile: "",
    istitution: "",
    city: "",
    nation: "",
    region: "",
    accept: false,
    type: "tfa_sostegno_estero",
  };

  FIELDS_GROUP = [
    [
      {
        id: "name",
        field: "name",
        label: "Nome",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "surname",
        field: "surname",
        label: "Cognome",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "dob",
        field: "dob",
        label: "Data di nascita",
        component: MInput,
        type: "date",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "email",
        field: "email",
        label: "Email",
        component: MInput,
        type: "email",
        className: "col-md-6",
      },
      {
        id: "mobile",
        field: "mobile",
        label: "Cellulare",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Università ESTERA presso il quale ha conseguito il corso di sostegno di 1500 ore e 60 CFU",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "city",
        field: "city",
        label: "Città ESTERA dove ha conseguito il titolo",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "nation",
        field: "nation",
        label: "Nazione ESTERA dove ha conseguito il titolo",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "region",
        field: "region",
        label: "Regione Italiana dove desidera svolgere la prova finale",
        payload: { options: this.PAYLOAD_REGION.options },
        component: MSelect,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "accept",
        field: "accept",
        label:
          "Dichiaro di aver letto la Privacy Policy ai sensi del Regolamento UE 2016/679 (GDPR)",
        component: MCheckbox,
        className: "col-md-12",
      },
    ],
  ];

  ERROR_MESSAGES = {
    name: "Inserisci il tuo nome",
    surname: "Inserisci il tuo cognome",
    email: "Inserisci la tua email",
    dob: "Seleziona la tua data di nascita",
    region: "Seleziona la regione",
    accept: "Accetta la privacy policy per continuare",
    mobile: "Inserisci il tuo numero di telefono",
    city: "Inserisci città",
    nation: "Inserisci nazione",
    istitution: "Inserisci università ESTERA presso il quale ha conseguito il corso di sostegno di 1500 ore e 60 CFU",
  };

  validation = {
    name: (value) => value !== "",
    surname: (value) => value !== "",
    competitionClass: (value) => value !== "",
    region: (value) => value !== "",
    email: (value) => /\S+@\S+\.\S+/.test(value),
    accept: (value) => value !== false,
    mobile: (value) => value !== "",
    dob: (value) => value !== "",
    istitution: (value) => value !== "",
    nation: (value) => value !== "",
    city: (value) => value !== "",
  };

  saveRemote = () => {
    let payload = payloadBuilder(this.state);

    pageService
      .saveContactRequest(payload)
      .then((result) => {
        this.setState({ isSuccess: 200 });
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          this.setState({ isSuccess: 422 });
        }
      });
  };

  onCancel = () => {
    this.resetForm();
  };

  render() {
    let { formActive, defaultValues } = this.state;
    const { formValid, code } = this.renderFields(
      this.FIELDS_GROUP,
      defaultValues,
      formActive
    );

    const title =
      "";


    return (
      <>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
        </Helmet>
        <MSection>
          <Row>
            <Col>
              <div class="text-center">
                <h2>Percorso di Specializzazione Universitaria per le Attività di Sostegno Didattico agli Alunni con Disabilità</h2>
                <p>In attuazione del D.M. n. 77 del 24 aprile 2025 e ss.mm.ii - Art. 7 del D.L. 71/2024</p>
              </div>
              <hr />
              <p>L’Università comunica l’apertura delle iscrizioni ai percorsi universitari di specializzazione per le attività di sostegno didattico, rivolti ai docenti in possesso dei requisiti previsti dal D.M. n. 77 del 24 aprile 2025 e ss.mm.ii - Art. 7 del D.L. 71/2024. Il percorso è finalizzato al conseguimento del titolo universitario di specializzazione per il sostegno, valido su tutto il territorio nazionale.
              </p>
              <hr />
              <h5>Presentazione della domanda</h5>
              <ul>
                <li><a href="https://unicamillus.org/corsi/tfa-di-sostegno/48cfu-36cfu/?_gl=1*144kn73*_up*MQ..*_ga*MTkxNjQyMzk4MS4xNzczOTMwNjg4*_ga_XFJMNJBV5Q*czE3NzM5MzA2ODgkbzEkZzAkdDE3NzM5MzA2ODgkajYwJGwwJGgw#panoramica">Scuola secondaria di I Grado</a></li>
                <li><a href="https://unicamillus.org/corsi/tfa-di-sostegno/48cfu-36cfu/?_gl=1*144kn73*_up*MQ..*_ga*MTkxNjQyMzk4MS4xNzczOTMwNjg4*_ga_XFJMNJBV5Q*czE3NzM5MzA2ODgkbzEkZzAkdDE3NzM5MzA2ODgkajYwJGwwJGgw#panoramica">Scuola secondaria di II Grado</a></li>
              </ul>
              <p><b>SCADENZA ISCRIZIONI: 19 Maggio 2026 ore 15:00</b></p>
              <hr />
              {/*<ul>
                <li><a href="/assets/doc/DR_366_Bando ammissione_percorsi_specializzazione_36_48_CFU.pdf" target="_blank">Bando di partecipazione</a></li>
                <li><a href="/assets/doc/Allegato_B_DR_366.pdf" target="_blank">Allegato B</a></li>
                <li><a href="/assets/doc/guida-iscrizione_estero.pdf" target="_blank">Guida all’iscrizione</a></li>
                <li>Iscrizione <a href="https://unicamillus-studenti.gomp.it/" target="_blank">https://unicamillus-studenti.gomp.it/</a> (entro le ore 15 di Mercoledì 16 Luglio)</li>
                <li><a href="/assets/doc/informativa_avviso_sostegno_estero.pdf" target="_blank">Privacy</a></li>
              </ul>
              <p><a href="https://www.mim.gov.it/web/guest/faq20" target="_blank">FAQ Estero (art. 7 del D.L.n. 71/2024)</a></p>
              <hr />*/}
              <h5>Requisiti di accesso</h5>
              <h5>Percorso di specializzazione 48 CFU e 36 CFU</h5>
              <p>Possono accedere i docenti in possesso del titolo di studio necessario all'insegnamento nello specifico grado scolastico e che abbiano superato presso un’Università estera legalmente accreditata nel paese di origine un percorso formativo sul sostegno agli alunni con disabilità, svolto prevalentemente su territorio dell’Unione europea, con durata non inferiore a 1500 ore o, in alternativa, idoneo al conseguimento di almeno 60 CFU e che abbiano presentato apposita istanza di riconoscimento per la quale, alla data del 24 aprile 2025, siano decorsi i termini di conclusione del relative procedimento.
              </p>
              <p>L’iscrizione a questi percorsi di formazione è subordinata alla rinuncia formale a ogni istanza di riconoscimento del percorso formativo svolto all’estero sul sostegno.</p>
              <p><b>Per l’acceso al percorso da 36 CFU</b> il candidato deve inoltre aver maturato, alla data di presentazione della domanda di partecipazione a questi percorsi, almeno un anno scolastico in Italia quale docente su posto di sostegno sullo specifico grado scolastico d’interesse.</p>
              <hr />
              <h5>Struttura del percorso</h5>
              <h5>Percorso di specializzazione 48 CFU</h5>
              <p>Il percorso formativo, della durata minima di 3 mesi, prevede:</p>
              <ul>
                <li>Acquisizione di 48 CFU (crediti formativi universitari)</li>
                <li>Lezioni sincrone online, con una quota massima del 10% in modalità asincrona</li>
                <li>Laboratori didattici sincroni, specifici per ogni grado scolastico</li>
                <li>Attività di tirocinio diversificate per grado d’istruzione</li>
                <li>Esami intermedi in presenza (valutazione in trentesimi)</li>
                <li>Esame finale in presenza, con discussione di un elaborato su un caso didattico</li>
              </ul>
              <p>Le assenze sono consentite fino a un massimo del 10% del monte ore complessivo. Non è previsto il riconoscimento di crediti pregressi da altri percorsi.
              </p>
              <h5>Percorso di specializzazione 36 CFU</h5>
              <p>Il percorso formativo, della durata minima di tre mesi, prevede:</p>
              <ul>
                <li>Acquisizione di 36 CFU (crediti formativi universitari)</li>
                <li>Lezioni sincrone online, con una quota massima del 10% in modalità asincrona</li>
                <li>Laboratori didattici sincroni, specifici per ogni grado scolastico</li>
                <li>Esami intermedi in presenza (valutazione in trentesimi)</li>
                <li>Esame finale in presenza, con discussione di un elaborato su un caso didattico</li>
              </ul>
              <p>Le assenze sono consentite fino a un massimo del 10% del monte ore complessivo. Non è previsto il riconoscimento di crediti pregressi da altri percorsi.
              </p>
              <hr />
              <h5>Costi</h5>
              <p>Contributo pari a € 50,00 per la presentazione della domanda di ammissione.</p>
              <h5>Percorso di specializzazione 48 CFU</h5>
              <p>Partecipazione € 1.500, suddiviso in tre rate:</p>
              <ul>
                <li>€156 entro i termini dell’immatricolazione (comprensivo di marca da bollo)</li>
                <li>€647 entro il 31/07/2026</li>
                <li>€647 entro il 30/09/2026</li>
              </ul>
              <h5>Percorso di specializzazione 36 CFU</h5>
              <p>Partecipazione € 900, suddiviso in tre rate:</p>
              <ul>
                <li>€156 entro i termini dell’immatricolazione (comprensivo di marca da bollo)</li>
                <li>€347  entro il 31/07/2026</li>
                <li>€347  entro il 30/09/2026</li>
              </ul>
              <hr />
              <h5>Modalità di pagamento</h5>
              <p>con PagoPA o Carta docenti (la Carta può essere utilizzata esclusivamente per il pagamento della seconda e/o terza rata)</p>
              <hr />
              <h5>Graduatorie e perfezionamento iscrizione</h5>
              <p>Le graduatorie e tutte le informazioni riferite alle procedure di immatricolazione verranno pubblicate ai seguenti link  <a href="https://unicamillus.org/">www.unicamillus.org</a>  <a href="https://www.formazionedocenti.it/adesioni-tfa-sostegno-estero">https://www.formazionedocenti.it/adesioni-tfa-sostegno-estero</a>
                e avranno valore di notifica ufficiale. In caso di rinuncia, si procederà allo scorrimento.</p>
              <p>L’iscrizione al percorso non è compatibile con altri corsi a frequenza obbligatoria.</p>
              <p>Il titolo universitario di specializzazione verrà rilasciato ai candidati che avranno frequentato almeno il 90% delle attività, superato tutti gli esami previsti e completato i versamenti richiesti.</p>
              <p>Entrambi i percorsi si svolgeranno in non meno di 3 mesi. Gli esami finali si svolgeranno in autunno 2026.</p>
              <p>Per eventuali informazioni:</p>
              {/*<p>Indirizzo email: <a href="mailto:sostegnoindire@formazionedocenti.it">sostegnoindire@formazionedocenti.it</a></p>*/}
              <p><b>ATTENZIONE:</b></p>
              <p>A causa dei tempi estremamente ristretti e vista l’elevata richiesta di notizie, tutte le informazioni relative ai suddetti corsi saranno rese disponibili esclusivamente attraverso il presente sito web e tramite la propria area riservata.
              </p>
              <hr />
              <h5>Graduatorie delle procedure concorsuali pregresse</h5>
              <p>Al seguente link potete consultare le graduatorie <a href="https://unicamillus.org/corsi/tfa-di-sostegno/48cfu-36cfu/" target="_blank" rel="noopener noreferrer">https://unicamillus.org/corsi/tfa-di-sostegno/48cfu-36cfu/</a></p>
              <hr />
              <h5>CALENDARIO DELLE ATTIVITÀ DIDATTICHE</h5>
              <p>Il calendario delle attività didattiche è disponibile nell’area riservata degli ammessi.</p>
            </Col>
          </Row>
        </MSection >
      </>
    );
  }
}